module.exports = __webpack_public_path__ + "img/symbol_3.406a36c0.png";